<!--退货报表-->
<template>
	<div>
		<h3>退货报表</h3>
		<div class="item">
			<div>
				<el-form ref="form" :model="form" inline :rules="rules" label-width="100px">
					<el-form-item label="退货单号" prop="workId">
						<el-input  v-model="form.workId"></el-input>
					</el-form-item>
                    <el-form-item label="商品名称" prop="productName">
						<el-input placeholder="全部商品" :value="form.productName" @focus="productfocus"></el-input>
					</el-form-item>
					<el-form-item label="退货单位" prop="forwardUnit">
						<el-input :value="form.forwardUnit" ></el-input>
					</el-form-item>
                    <el-form-item label="收货单位" prop="ReceiveUnit">
						<el-input :value="form.ReceiveUnit" ></el-input>
					</el-form-item>
					<el-form-item label="退货日期" prop="date">
                        <el-date-picker
                        v-model="form.date"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
				</el-form>
				<span style="margin: 0 0 20px 100px;">
                    <el-button type="primary" @click="SeloutData">搜 索</el-button>
					<el-button @click="restForm" type="warning">重 置</el-button>
				</span>
			</div>
            <el-dialog
			title="选择商品"
			:visible.sync="productVisible"
			width="600px">
                <el-table :data="productData" highlight-current-row>
                    <el-table-column align="center" width="80" property="DataId"></el-table-column>
                    <el-table-column align="center" width="80" property="Productcode" label="商品编号"></el-table-column>
                    <el-table-column align="center" width="200" property="Productname" label="商品名称"></el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                             <el-button type="primary" @click="confirm(scope)">选 择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
		</div>
		<div class="item">
			<el-table :data="tableData" highlight-current-row border>
				<el-table-column align="center" property="id"   label="退货单号"></el-table-column>
				<el-table-column align="center" property="num"  label="退库时间"></el-table-column>
				<el-table-column align="center" property="name" label="退库类型"></el-table-column>
				<el-table-column align="center" property="name" label="商品名称"></el-table-column>
				<el-table-column align="center" property="name" label="商品规格"></el-table-column>
				<el-table-column align="center" property="name" label="计划数量"></el-table-column>
				<el-table-column align="center" property="name" label="实际数量"></el-table-column>
				<el-table-column align="center" property="name" label="退货单位"></el-table-column>
				<el-table-column align="center" property="name" label="收货单位"></el-table-column>
				<el-table-column align="center" property="name" label="订单状态"></el-table-column>
				<el-table-column align="center" property="name" label="详情"></el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				workId:'',
				productnum:'',
				productName:'',
                forwardUnit:'',
                ReceiveUnit:'',
                deliveryType:'',
				date:'',
			},
			rules: {
        		date:[
          			{ required: true, message: '请选择时间'}
        		]
			},
			productData:[],
			DeliveryType:[{
				type:0,
				storage:"销售出库"
			},{
				type:1,
				storage:"销毁出库"
			},{
				type:2,
				storage:"调拨出库"
			}],
			tableData: [],
            productVisible: false
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.form.CID=user.QyNum;

	},
	methods: {
		productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		confirm(scope){ //选中商品
			this.form.productnum = scope.row.Productcode;
			this.form.productName = scope.row.Productname;
			this.productVisible = false
		},
		restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
		},
		SeloutData(){
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/returnData.ashx',
				params: {
					action:"SelreturnData",
					CID:user.QyNum,
					form:this.form
				}
				}).then(res=>{
				if(res.Code==0){
					this.tableData=res.Data;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/returnData.vue